import React, { Component } from 'react';

class Home extends Component {
  render() {
    return (
    <div className="landing">
        <h3>Generation Information</h3>
 <div>
<p align="justify">
Welcome to the official Forest Hills Cemetery website. Located in the historic St. Elmo neighborhood nestled at the foot of Lookout Mountain, FHC is the resting place of many important people and a landmark of great beauty and history to Chattanooga, Tennessee.
</p>
<p align="justify">
    
</p>
<br />
<h3>Pricing</h3>
<a href="./documents/Cemetery_Pricing_Current.pdf" target="_blank">Click here</a> to download our <b>pricing sheet</b>.
<br />
<br />
<h3>Grave Decoration Policy</h3>
<a href="./documents/Cemetery_Grave_Decoration_Policy.pdf" target="_blank">Click here</a> to download our <b>Grave Decoration Policy</b>.
<br />
<br />
<h3>The History of Forest Hills</h3>
<p align="justify">Located in St. Elmo at the foot of Lookout Mountain, Forest Hills Cemetery was established in 1880 by a group led by Colonel Abraham Malone Johnson. Forest Hills houses the gravesites of Civil Wars officers, entertainers, industrialists, and even a United States postmaster general. However, Forest Hills is more than a burial ground. It is a monument of history and art. Historical periods are evident in the gravestones. A separate area for African Americans, many of whom were slaves before the civil war, is a relic from the era of segregation. Times of epidemics and wars are visible in the cemetery's records as well as causes like cholera, consumption, and insanity. Historical figures of Chattanooga are buried here as well as unknowns like children from the Vine Street orphanage. The historical significance of Forest Hills is equal to its beauty. The monuments here are marvelous examples of Gothic, Victorian, and modern art styles. There are carvings of Biblical figures, Greek gods, and effigies of the deceased, grand mausoleums, display stain glass windows and stately sculpture vaults.</p>
<p align="justify">This cemetery is a sanctuary of magnificent botanical beauty. Vibrant spruce trees, wildflowers, dogwoods, azaleas, and fruit trees flourish here. Cuttings from the rare species in the graveyard are used for transplanting in other parts of the country. In the spring, many people enjoy an afternoon drive through the cemetery to see its astounding flora. Forest Hills is a place of beauty, history, and great importance to the community.</p>
</div>
 <div>
 &nbsp;
 </div>
 <div>
<a href="./search"><img width="200" alt="Search the burial records" border="0" src="./images/ForestHillsCemeteryLogo.png" /></a><br />
<img alt="FHC Lawn" width="200" src="./images/FHCLawn.png" /><br />
 <h3>FHC book available!</h3>
<p align="justify">
Forest Hills Cemetery would like to announce the availability of a new book. The book is available at the office for $25.00. It was written by a volunteer by the name of Gay Moore and is entitled Images of America Chattanooga's Forest Hills Cemetery.
</p>
</div>
 <br />

    </div>
    );
  }
}

export default Home
